export enum MapSourceId {
  supplierGeoData = 'supplier-geo-data',
  locationGroupData = 'location-group-data',
}

export enum MapLayerId {
  supplierGeoClusters = 'supplier-geo-clusters',
  supplierGeoClusterCount = 'supplier-geo-cluster-count',
  supplierGeoUnClusteredPoint = 'supplier-geo-unclustered-point',
  locationGroupFill = 'location-group-fill',
  locationGroupOutline = 'location-group-outline',
  locationGroupName = 'location-group-name',
}

export interface MapPopupInfo {
  id: string;
  name: string;
  lat: number;
  lng: number;
}

export interface MapViewState {
  longitude: number;
  latitude: number;
  zoom: number;
}

export enum MapMarkerVariant {
  PRIMARY = 'primary',
  DEFAULT = 'default',
}

export interface MapMarkerOptions {
  variant: MapMarkerVariant;
  fill: string;
  fillOpacity: number;
}
